// Single-line address formatting for list-table columns (Leads/Customers/
// Suppliers/All Entities' own optional "Address" column) — Country is
// deliberately left out since every one of those screens already carries
// its own separate Country column, and repeating it here would just be
// noise.
export function formatAddress(address) {
  if (!address) return '';
  return [address.line1, address.line2, address.district, address.suburb, address.state, address.postcode]
    .filter(Boolean)
    .join(', ');
}
